module.exports = __webpack_public_path__ + "img/register.8b01b900.svg";